import { useEffect, useState } from 'react';
import * as Yup from 'yup';

import { WizardStepValidationPreviousSteps } from '../context/interfaces';

function useValidatePreviousSteps(props: WizardStepValidationPreviousSteps): boolean {
  const { validatePreviousSteps: enabled, currentStepId, context, steps } = props;
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    async function validatePreviousStep() {
      if (!enabled) return true;

      const orderedSteps = [steps].find(flow => flow.find(step => currentStepId === step.id)) || [];

      for (const step of orderedSteps) {
        if (currentStepId === step.id) {
          break;
        }

        if (!step.validation?.schema) continue;

        try {
          await (step.validation?.schema as Yup.Schema<any>).validate(context.form.values);
        } catch {
          context.wizard.dispatch({
            type: 'GOTO_STEP',
            stepId: step.id,
            values: context.form.values
          });
          return false;
        }
      }

      return true;
    }

    void validatePreviousStep().then(output => setIsMounted(output));
  }, [enabled, currentStepId]);

  return isMounted;
}

export default useValidatePreviousSteps;
